import React, { Component } from 'react';
import {interpolateRgb} from 'd3-interpolate';
import SimilarNeighborhoodsList from './SimilarNeighborhoodsList';
import DistributionGraph from './DistributionGraph';
import YearGraph from './YearGraph';

class HexFocus extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      toggles: {
        probability_1_toggle: false,
        probability_2_toggle: false,
        price_1_toggle: false,
        price_2_toggle: false
      }
    }
  }

  handleToggle(target, event) {
    this.setState({ toggles: { ...this.state.toggles, [target]: !this.state.toggles[target] } })
    event.stopPropagation()
  }

  clearToggles() {
    let clear_state = {
      probability_1_toggle: false,
      probability_2_toggle: false,
      price_1_toggle: false,
      price_2_toggle: false
    }
    this.setState({ toggles: clear_state })
  }

  render() {
    const {active_neighborhood, active_mode, active_price, active_year, active_probability, formatters, closeNeighborhoodFocus, closeHexFocus, neighborhoods, neighborhoods_samples, setActiveNeighborhood, interpolators, top_space, active_hex, browser_width} = this.props;
    const {toggles} = this.state;

    const prob_categories = ['High', 'Medium', 'Low'];
    const category_step = 1/prob_categories.length;

    const getLevel = (value) => {
      let level = '';
      if (value < category_step) {
        level = 'low';
      } else if (value < category_step * 2) {
        level = 'medium';
      } else {
        level = 'high';
      }
      return level;
    }

    const getLevelPhrase = (value) => {
      let phrase;
      if (value < category_step) {
        phrase = 'a low';
      } else if (value < category_step * 2) {
        phrase = 'a reasonable (medium)';
      } else {
        phrase = 'a high';
      }
      return phrase;
    }

    const getProbabilityIndex = (value) => {
      if (value === 0.25) {
        return 0;
      } else if (value === 0.5) {
        return 1;
      } else {
        return 2;
      }
    }

    const getPriceText = (value) => {
      if (value === 0.25) {
        return 'a low';
      } else if (value === 0.5) {
        return 'a medium';
      } else {
        return 'a high';
      }
    }

    const handleClose = () => {
      closeHexFocus();
    }

    const handleNeighborhoodClose = () => {
      closeHexFocus();
      closeNeighborhoodFocus();
    }

    const addPlus = (string) => {
      let new_string = string;
      if (string.indexOf('-') === -1) new_string = '+' + string;
      return new_string;
    }

    const years = [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];
    const year_index = years.indexOf(active_year);

    const active_year_probability_price = active_hex.year_all_prices[year_index][getProbabilityIndex(active_probability)];

    const focus_spacer = 16;

    let focus_background = interpolators.chance(active_neighborhood.properties.probability);
    if (active_mode !== 'Chance') {
      focus_background = interpolators.money(active_neighborhood.properties.price/2000000)
    }

    let hex_focus_background = interpolators.chance(active_hex.properties.probability);
    if (active_mode !== 'Chance') {
      hex_focus_background = interpolators.money(active_hex.properties.price/2000000)
    }

    let mobile = false;
    if (browser_width < 451) mobile = true;

    return (
      <div className="tnum relative fixed bg-white"
        style={{
          width: mobile ? '100%' : '360px',
          top: top_space,
          height: `calc(100% - ${top_space}px`,
          overflowY: 'auto'
        }}
      >
        <div className="">
          <div className="py1 bg-transparent-fafafa fixed"
            style={{
              top: top_space,
              zIndex: 11,
              width: mobile ? '100%' : '360px',
              background: focus_background
            }}
            onClick={handleClose}
          >
            <div className="uppercase relative lh1 px2 h6">
              neighborhood
            </div>
            <div className="absolute center lh1 right-0 light-hover top-0 h1 Closer"
              onClick={handleNeighborhoodClose}
              style={{
                width: '3rem',
                height: '1.75rem',
                top: '0px',
                lineHeight: '1.75rem',
              }}>&times;</div>
          </div>
          <div className="py1 bg-transparent-fafafa fixed border-top"
            style={{
              top: top_space + 28,
              zIndex: 11,
              width: mobile ? '100%' : '360px',
              background: hex_focus_background
            }}
          >
            <div className="uppercase relative lh1 px2 h6">
              hex
            </div>
            <div className="absolute center lh1 right-0 light-hover top-0 h1 Closer" style={{
                width: '3rem',
                height: '1.75rem',
                top: '0px',
                lineHeight: '1.75rem',
              }} onClick={handleClose}>&times;</div>
          </div>
          <div className="relative mt4 px2">
            <div className="relative">
              <div className="h3 truncate" title={active_neighborhood.properties.neighborhood}>
                Hex {active_hex.properties.hexid}
              </div>
              <div className="h5 capitalize">
                {active_neighborhood.properties.neighborhood}, {active_neighborhood.properties.borough}
              </div>
            </div>
          </div>
          {active_mode ==='Chance' ? (
            <div className="tnum mt1">
              <div className="px2 h4">
                You would have a {getLevel(active_hex.properties.probability)} ({formatters.percentFormat(active_hex.properties.probability)}) probability of being able to afford a property for {formatters.dollarShort(active_price)} in {active_year}.
              </div>
            </div>
          ) : (
            <div>
              <div className="mt1 uppercase flex space-between h6 px2">
                <div>
                  Price by Probability
                </div>
              </div>
              <div className="py1 px2 tnum flex">
                {active_hex.year_all_prices[year_index].map((price,i) =>
                  <div
                    className={"px2 py1 col-4 center"}
                    key={i}
                    title={getLevel(0.25 + 0.25 * i).replace(/\b\w/g, l => l.toUpperCase()) + ` (${formatters.percentFormat(0.25 + 0.25 * i)})`}
                    style={{
                      background: (price === active_year_probability_price ? '#222' : '#efefef'),
                      color: (price === active_year_probability_price ? '#fff' : '#222')
                    }}
                  >
                    {price === active_year_probability_price ?
                      (formatters.dollarThree(price))
                      :
                      (
                        addPlus(formatters.dollarShort(price - active_year_probability_price).replace('$',''))
                      )
                    }
                  </div>
                )}
              </div>
              <div className="px2 h5">
                You would need {formatters.dollarThree(active_hex.properties.price)} to have {getLevelPhrase(active_probability)} probability you could afford a property in {active_year}.
              </div>
            </div>
          )}
          <div className="relative">
            <div className="h6 mt2 px2 uppercase">
              Probability Distribution for {active_year}
            </div>
            {active_mode === 'Chance' ? (
              <div className="graph-question-holder">
                <div
                  className={"graph-question hover no-select " + (toggles['probability_1_toggle'] ? 'active' : null)}
                  onClick={this.handleToggle.bind(this, 'probability_1_toggle')}
                >?</div>
                {toggles['probability_1_toggle'] ? (
                  <div className="graph-question-tip">
                    {`This graph shows the distribution of prices for 500 samples for ${active_hex.properties.hexid} in ${active_year} drawn from our model. The black line is the current price of ${formatters.dollarShort(active_price)}, set above. The probability you would be available to afford a property is the fraction of samples to the left of the line.`}
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="graph-question-holder">
                <div
                  className={"graph-question hover no-select " + (toggles['price_1_toggle'] ? 'active' : null)}
                  onClick={this.handleToggle.bind(this, 'price_1_toggle')}
                >?</div>
                {toggles['price_1_toggle'] ? (
                  <div className="graph-question-tip">
                    {`This graph shows the distribution of prices for 500 samples for ${active_hex.properties.hexid} in ${active_year} drawn from our model. The black line is the amount required to have a ${getLevel(active_probability)} (${formatters.percentFormat(active_probability)}) chance of being able to afford a property. This probability is the fraction of samples to the left of the line. The gray band behind the line is the range between the low (25%) and high (75%) probability.`}
                  </div>
                ) : null}
              </div>
            )}
          </div>
          <div className="">
            <DistributionGraph
              active_neighborhood={active_hex}
              active_year={active_year}
              active_price={active_price}
              active_mode={active_mode}
              active_probability={active_probability}
              interpolators={interpolators}
              formatters={formatters}
            />
          </div>
          <div className="relative">
            <div className="h6 mt1 px2 uppercase">
              Probability by Year
            </div>
            {active_mode === 'Chance' ? (
              <div className="graph-question-holder">
                <div
                  className={"graph-question hover no-select " + (toggles['probability_2_toggle'] ? 'active' : null)}
                  onClick={this.handleToggle.bind(this, 'probability_2_toggle')}
                >?</div>
                {toggles['probability_2_toggle'] ? (
                  <div className="graph-question-tip">
                    {`This graph shows the probability by year that you would be able to afford a property at ${formatters.dollarShort(active_price)}.`}
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="graph-question-holder">
                <div
                  className={"graph-question hover no-select " + (toggles['price_2_toggle'] ? 'active' : null)}
                  onClick={this.handleToggle.bind(this, 'price_2_toggle')}
                >?</div>
                {toggles['price_2_toggle'] ? (
                  <div className="graph-question-tip">
                    {`This graph shows the amount you would need to be able to afford a property by year. The gray area is the range between the a low (25%) and high (75%) probability. The black line is the currently chosen probability: ${getLevel(active_probability)} (${formatters.percentFormat(active_probability)}).`}
                  </div>
                ) : null}
              </div>
            )}
          </div>
          <div className="">
            <YearGraph
              active_neighborhood={active_hex}
              active_mode={active_mode}
              formatters={formatters}
              active_year={active_year}
            />
          </div>
          <div className="py1"></div>
        </div>
      </div>
    )
  }
}

export default HexFocus;


/** WEBPACK FOOTER **
 ** ./src/components/HexFocus.js
 **/